import { render, staticRenderFns } from "./EnvironmentBadge.vue?vue&type=template&id=71f5d5d4&scoped=true&"
import script from "./EnvironmentBadge.vue?vue&type=script&lang=js&"
export * from "./EnvironmentBadge.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentBadge.vue?vue&type=style&index=0&id=71f5d5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f5d5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f5d5d4')) {
      api.createRecord('71f5d5d4', component.options)
    } else {
      api.reload('71f5d5d4', component.options)
    }
    module.hot.accept("./EnvironmentBadge.vue?vue&type=template&id=71f5d5d4&scoped=true&", function () {
      api.rerender('71f5d5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/EnvironmentBadge.vue"
export default component.exports